import { ReactNode } from 'react'
import { BreadcrumbPath } from '@/components/page/pageHeader'
import { PageHeader } from '../page/pageHeader'

type PageLayoutProps = {
  children: ReactNode
  title: string
  path: BreadcrumbPath[]
}

const PageLayout = ({ children, title, path }: PageLayoutProps) => {
  return (
    <div className="space-y-4">
      <PageHeader title={title} path={path} />
      {children}
    </div>
  )
}

export { PageLayout }
